<script lang="ts">
  type Group = 'standard' | 'bespoke';
  type Role = { id: number; name: string; label: string; description: string | null; group: Group };

  export let roles: Role[] = [];
  export let selectedNames: string[] = [];
  export let inputName: string;

  // "bespoke" is the data-model term; the UI says "custom".
  const sections: { key: Group; title: string | null; hint: string | null }[] = [
    { key: 'standard', title: null, hint: null },
    {
      key: 'bespoke',
      title: 'Custom roles',
      hint: 'One-off roles for specific employees or small groups.',
    },
  ];

  $: grouped = sections
    .map((section) => ({ ...section, roles: roles.filter((role) => role.group === section.key) }))
    .filter((section) => section.roles.length > 0);
</script>

{#each grouped as section (section.key)}
  <div class={`role-picker-group role-picker-${section.key} mb-3`}>
    {#if section.title}
      <h3 class="h6 text-muted mb-1">
        {section.title}
        {#if section.hint}
          <small class="fw-normal fst-italic">— {section.hint}</small>
        {/if}
      </h3>
    {/if}
    <div class="row">
      {#each section.roles as role (role.id)}
        <div class="col-md-6 col-lg-4">
          <div class="form-check">
            <input
              class="form-check-input"
              type="checkbox"
              id={`employee_form_roles_${role.name}`}
              name={inputName}
              value={role.name}
              bind:group={selectedNames}
            />
            <label
              class={`form-check-label ${section.key === 'bespoke' ? 'text-muted fst-italic' : ''}`}
              for={`employee_form_roles_${role.name}`}
            >
              {role.label}
              {#if role.description}
                <div class="form-text">{role.description}</div>
              {/if}
            </label>
          </div>
        </div>
      {/each}
    </div>
  </div>
{/each}
